/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Types_QuestionInputs */

const es_feedback_types_question = /** @type {(inputs: Feedback_Types_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pregunta`)
};

const en_feedback_types_question = /** @type {(inputs: Feedback_Types_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Question`)
};

/**
* | output |
* | --- |
* | "Question" |
*
* @param {Feedback_Types_QuestionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_types_question = /** @type {((inputs?: Feedback_Types_QuestionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Types_QuestionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_types_question(inputs)
	return en_feedback_types_question(inputs)
});
export { feedback_types_question as "feedback.types.question" }